module.exports = __webpack_public_path__ + "static/depo-fernanda-rosto-adef6486e8d9eebd6ceec731f61283d3.png";